<template>
  <div>
    <div class="change-history-row-info">
      <span>{{ $t('common.common_before-fix-information') }}</span>
    </div>
    <ConfirmationBoxes :detail="client">
      <template #box2="{ item }">
        <template v-if="items.orderEditHistoryProduct !== undefined">
          <v-row no-gutters>
            <v-col cols="4">{{ $t('common.input_currency') }}</v-col>
            <v-col>{{ item.currency.label }} </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="4">{{ $t('order.order_order-date') }}</v-col>
            <v-col>{{ item.orderDate }} </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="4"
              >{{ $t('order.order_suggested-loading-date') }}
            </v-col>
            <v-col>{{ item.deliveryDate }} </v-col>
          </v-row>
        </template>
        <template v-else-if="items.saleEditHistoryProduct !== undefined">
          <v-row no-gutters>
            <v-col cols="4"> {{ $t('user.user_customer-name') }} </v-col>
            <v-col>{{ item.customerName }}</v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="4">
              {{ $t('sale.sale_customer-company-name') }}
            </v-col>
            <v-col> {{ item.organizationName }} </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="4"> {{ $t('sale.sale_customer-store-name') }} </v-col>
            <v-col>{{ item.shopName }} </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="4"> {{ $t('common.input_currency') }} </v-col>
            <v-col>{{ item.currency.label }} </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="4">注文日 </v-col>
            <v-col>{{ item.saleDate }} </v-col>
          </v-row>
        </template>
      </template>
    </ConfirmationBoxes>
  </div>
</template>
<script>
import { ConfirmationBoxes } from '@/components/items'
import SpplierInfo from './SpplierInfo'
import CustomerInfo from './CustomerInfo'
export default {
  components: { ConfirmationBoxes },
  props: {
    items: { default: {} },
    recItems: {
      type: Object,
      require: false,
      default: () => ({})
    }
  },
  created() {
    this.init()
  },
  data: () => ({
    client: []
  }),
  methods: {
    init() {
      if (this.items.orderEditHistoryProduct !== undefined) {
        this.client = SpplierInfo.setHistoryInfo(this.items)
      } else if (this.items.saleEditHistoryProduct !== undefined) {
        this.client = CustomerInfo.setHistoryInfo(this.items)
      }
    }
  },
  watch: {
    recItems: {
      deep: true,
      handler(newVal, oldVal) {
        this.init()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.headingStyle {
  font-size: 15px;
  font-weight: bold;
}
.change-history-row-info {
  text-align: center;
  height: 36px;
  line-height: 36px;
  background-color: rgba(151, 198, 234, 0.1);
}
</style>
